//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'
export default {
  name: 'rb-vertical-banner',
  components: {
    RbBanner,
  },
  props: {
    numberOfBanners: {
      type: Number,
      required: true,
    },
  },
  inject: {
    isActiveSlide: {
      default: false,
    },
  },
  data() {
    return {
      autoplay: false,
    }
  },
  computed: {
    isCurrentSlidePlaying() {
      return this.isActiveSlide && this.isActiveSlide()
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    fixedHeight() {
      return this.numberOfBanners === 2 ? 672 : ''
    },
  },
  watch: {
    isCurrentSlidePlaying(val) {
      if (val) {
        this.play()
      } else {
        this.pause()
      }
    },
  },
  mounted() {
    if (this.isCurrentSlidePlaying) {
      this.autoplay = true
    }
  },
  methods: {
    play() {
      this.$refs.banner.play()
    },
    pause() {
      this.$refs.banner.pause()
    },
    onViewportIntersection(event) {
      if (!this.isMobile) {
        return
      }

      if (event.percentInView >= 0.6 && this.isCurrentSlidePlaying) {
        this.play()
      } else {
        this.pause()
      }
    },
  },
}
